import { DEFAULT_FREE_TEXT_DELIMITER } from '@pm/forms';
import {
  QuestionnaireAnswerFragment,
  QuestionnaireQuestionFragment,
} from '@pm/graphql';

// FormRadioGroup prefixes free-text answers with this before submission
const RADIO_FREE_TEXT_PREFIX = DEFAULT_FREE_TEXT_DELIMITER;

const DEFAULT_FORMAT = (value: string) => [value];

const DATA_FORMATS: Record<
  NonNullable<QuestionnaireQuestionFragment['__typename']>,
  (value: $TSFixMe) => string[]
> = {
  QuestionnaireRadioQuestion: (value: string) => [
    value.startsWith(RADIO_FREE_TEXT_PREFIX)
      ? value.slice(RADIO_FREE_TEXT_PREFIX.length)
      : value,
  ],
  QuestionnaireTextInputQuestion: DEFAULT_FORMAT,
  QuestionnaireNumberInputQuestion: (value: number) => [String(value)],
  QuestionnaireTextAreaQuestion: DEFAULT_FORMAT,
  QuestionnaireDateInputQuestion: DEFAULT_FORMAT,
  QuestionnaireCheckboxQuestion: (value: string[]) => value,
};
export const formatAnswerForDataType = (
  answer: string | number | string[],
  typename: QuestionnaireQuestionFragment['__typename'],
): string[] => {
  if (typename === undefined) {
    return [''];
  }

  const formatter = DATA_FORMATS[typename];

  return formatter(answer);
};

export const formatAnswerForInputType = (
  answer: QuestionnaireAnswerFragment | undefined,
  question: QuestionnaireQuestionFragment,
): string[] | string => {
  if (question.__typename === 'QuestionnaireCheckboxQuestion') {
    return answer?.values ?? [];
  }

  const rawValue = answer?.values.join(',') || '';

  if (question.__typename === 'QuestionnaireRadioQuestion' && rawValue) {
    const hasFreeTextOption = question.acceptableAnswers.some(
      (acceptableAnswer) => acceptableAnswer.value === null,
    );
    const matchesAnAcceptableAnswer = question.acceptableAnswers.some(
      (acceptableAnswer) => acceptableAnswer.value === rawValue,
    );

    if (hasFreeTextOption && !matchesAnAcceptableAnswer) {
      return `${RADIO_FREE_TEXT_PREFIX}${rawValue}`;
    }
  }

  return rawValue;
};
